import React, { Component } from 'react';
import { Icon, Table, Menu, Button, Accordion } from 'semantic-ui-react'
import ResultsStore from '../store/ResultsStore'
import * as esriLoader from 'esri-loader';

export default class ResultsComponent extends Component {

  constructor() {
    super();
    window.globalBuildingsURL =
      "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/LPC_HistoricBuildings_Service/FeatureServer/0";

    this.hdURL = "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Historic_Districts/FeatureServer/0" + "/query?" +
      "returnGeometry=true&returnCentroid=false&returnCountOnly=false&returnDistinctValues=false";
    this.hdNameField = "AREA_NAME"
    this.hdLayerName = window.globalMap._layers["Historic_Districts_6973"]

    this.ilURL = "https://services5.arcgis.com/Oos4pNA2538iVFA1/ArcGIS/rest/services/Individual_Landmark_Lots_Poly/FeatureServer/0" + "/query?" +
      "returnGeometry=true&returnCentroid=false&returnCountOnly=false&returnDistinctValues=false";
    this.ilNameField = "LM_New"
    this.ilLayerName = window.globalMap._layers["Individual_Landmark_Lots_Poly_5969"]

    this.bldgURL = window.globalBuildingsURL + "/query?" +
      "returnGeometry=true&returnCentroid=false&returnCountOnly=false&returnDistinctValues=false";

    this.state = {
      activeIndex: -1,
      activeRowId: 0,
      hdResults: {},
      ilResults: {}
    };
  }

  componentDidMount() {
    this.startUpdatingHDResults();
    this.startUpdatingILResults();
  }

  render() {

    const { activeIndex } = this.state
    const historicDistrict = this.renderData("Hist_Dist", this.state.hdResults, this.hdURL, "AREA_NAME", "Historic Districts", this.hdLayerName, 10000)
    const individualLandmark = this.renderData("LM_New", this.state.ilResults, this.ilURL, "LPC_NAME", "Individual Landmarks", this.ilLayerName, 20000)

    return (
      <div>
        <table width="100%"><tbody>
        <tr>
          <td width="50%"><Button fluid style={ { "backgroundColor": "#C1272C", "color": "#fff" } } disabled onClick={this.tabChanged.bind(this, 'search')}>RESET</Button></td>
          <td width="50%"><Button fluid onClick={this.tabChanged.bind(this, 'search')}>EDIT FILTER</Button></td>
        </tr>
        </tbody></table>
        <b>FILTER RESULTS</b>
        {historicDistrict}
        {individualLandmark}
      </div>
    );
  }

  startUpdatingHDResults() {

    this.setState({updatingHDResults: true});

    const filterURL = window.globalBuildingsURL + "/query?" +
      "returnGeometry=false&returnCentroid=false";
    const whereClause = "&where=" + encodeURIComponent("HD_Flag=1 AND "+this.props.whereClause);
    const outputFormat = "&f=json";
    const outFields = "&outFields=OBJECTID,Hist_Dist,Des_Addres,HD_Flag";
    const orderByFields = "&orderByFields=HD_Flag,Hist_Dist,Des_Addres";

    const url = filterURL + outputFormat + outFields + whereClause + orderByFields;

    fetch(url).then(function(response) {
      return response.json();
    })
      .then(
        (json) => this.finishUpdatingHDResults(json)
      );
  }

  finishUpdatingHDResults(json) {
    if (typeof json['error'] !== "undefined") {
      console.error(json['error']);
      return;
    }
    this.setState({
      updatingHDResults: false,
      hdResults: json['features']
    });
  }

  startUpdatingILResults() {

    this.setState({updatingILResults: true});
    const filterURL = window.globalBuildingsURL + "/query?" +
      "returnGeometry=false&returnCentroid=false";
    const whereClause = "&where=" + encodeURIComponent("IL_Flag=1 AND "+this.props.whereClause);
    const outputFormat = "&f=json";
    const outFields = "&outFields=OBJECTID,LM_New,Des_Addres,IL_Flag";
    const orderByFields = "&orderByFields=IL_Flag,LM_New,Des_Addres";

    const url = filterURL + outputFormat + outFields + whereClause + orderByFields;

    fetch(url).then(function(response) {
      return response.json();
    })
      .then(
        (json) => this.finishUpdatingILResults(json)
      );
  }

  finishUpdatingILResults(json) {
    if (typeof json['error'] !== "undefined") {
      console.error(json['error']);
      return;
    }
    this.setState({
      updatingILResults: false,
      ilResults: json['features']
    });
  }

  renderData(keyName, results, itemURL, itemFieldName, itemTitle, itemLayer, indexStart) {

    const { activeIndex } = this.state
    if(Object.keys(results).length===0) return("")

    var itemName = results[0]["attributes"][keyName];
    var itemCount = indexStart;
    var bldgCount = 0;
    var contentString = [];
    var returnString = [];
    var seperator = [];

    for(let i=0; i<Object.keys(results).length;i++){
      let r = results[i]["attributes"];
      if(itemName===r[keyName]) {
        bldgCount++;
        // if(keyName==="Hist_Dist") {
          //TODO: add "key" attribute to each thing in the array.
          contentString.push(<div>
            <a href="#" className="address" onClick={this.handleRowClick.bind(this, itemLayer, r["OBJECTID"] )}>
                <p id={"Addr" + r["OBJECTID"]}>{r["Des_Addres"]}</p>
              </a><hr />
          </div>)
        // }
      }
      else {
        // if(keyName==="Hist_Dist") {
          returnString.push(<Accordion.Title active={activeIndex === itemCount} index={itemCount}
                                             onClick={this.handleItemClick.bind(this, keyName, itemURL, itemFieldName, itemLayer, itemCount, itemName)}>
            <table width='100%'>
              <tbody>
              <tr>
                <td><Icon name='dropdown'/></td>
                <td>{itemName}</td>
                <td align='right'>{bldgCount} result{bldgCount > 1 ? "s" : ""}</td>
              </tr>
              </tbody>
            </table>
          </Accordion.Title>)
          returnString.push(
            <Accordion.Content active={activeIndex === itemCount} >
              {contentString}
            </Accordion.Content>
          )
        // } else {
        //   returnString.push(<Accordion.Title active={activeIndex === itemCount} index={itemCount}
        //                                      onClick={this.handleItemClick.bind(this, keyName, itemURL, itemFieldName, itemLayer, itemCount, itemName)}>
        //         {itemName}
        //   </Accordion.Title>)

        // }
        itemCount++;
        bldgCount = 0;
        contentString = [];
        itemName=r[keyName];
        bldgCount++;
        // if(keyName==="Hist_Dist") {
          contentString.push(<div>
              <a href="#" className="address" onClick={this.handleRowClick.bind(this, itemLayer, r["OBJECTID"] )}>
                <p id={"Addr" + r["OBJECTID"]}>{r["Des_Addres"]}</p>
              </a><hr />
          </div>)
        // }
      }
    }

    // if(keyName==="Hist_Dist") {
      seperator = [<hr />]
      returnString.push(
        <Accordion.Title active={activeIndex === itemCount} index={itemCount}
                         onClick={this.handleItemClick.bind(this, keyName, itemURL, itemFieldName, itemLayer, itemCount, itemName)}>
            <table width='100%'>
              <tbody>
              <tr>
                <td><Icon name='dropdown'/></td>
                <td>{itemName}</td>
                <td align='right'>{bldgCount} result{bldgCount > 1 ? "s" : ""}</td>
              </tr>
              </tbody>
            </table>
        </Accordion.Title>
      )
      returnString.push(
        <Accordion.Content active={activeIndex === itemCount} >
          {contentString}
        </Accordion.Content>
      )
    // } else {
    //   returnString.push(<Accordion.Title active={activeIndex === itemCount} index={itemCount}
    //                                      onClick={this.handleItemClick.bind(this, keyName, itemURL, itemFieldName, itemLayer, itemCount, itemName)}>
    //     {itemName}
    //   </Accordion.Title>)
    // }


    return (
      <div>
        <style>
          {`
            .address:link    {color: gray}
            .address:visited {color: gray}
            .address:hover   {color: black}
            .address:active  {color: black}
          `}
        </style>
        <br />
        <b>{itemTitle}</b>
        <Accordion styled fluid>
          {returnString}
        </Accordion>
        <br />
        {seperator}
      </div>
    )
  }

  tabChanged(tabSelected) {
    this.props.updateFilterOnResultUpdate();
  }

  handleItemClick(keyName, itemURL, itemFieldName, itemLayer, itemCount, itemName) {
    const index = itemCount
    const activeIndex = this.state.activeIndex
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
    this.highlightArea(keyName, itemURL, itemFieldName, itemName, itemLayer)
  }

  handleRowClick(itemLayer, itemObjectID) {
    if(this.state.activeRowId > 0) {
      document.getElementById("Addr" + this.state.activeRowId).style.fontWeight = "normal";
      document.getElementById("Addr"+this.state.activeRowId).style.color = "gray";
    }
    this.setState({activeRowId:itemObjectID})
    document.getElementById("Addr"+itemObjectID).style.fontWeight = "bold";
    document.getElementById("Addr"+itemObjectID).style.color = "black";
    const buildingsLayer = itemLayer;
    const whereCl = "OBJECTID=" + itemObjectID;

    this.highlightBuilding(itemObjectID)

    //https://developers.arcgis.com/javascript/3/jssamples/popup_sidepanel.html
  }
  handleRowChange(itemLayer, itemObjectID) {

  }
  highlightArea (keyName, areaUrl, areaFieldName, areaName, areaLayer) {

    const whereCl = areaFieldName + "=\'" + areaName.replace(/'/g, "''") + "\'";
    const whereClause = "&where=" + encodeURIComponent(whereCl);
    const outSpatialRef = "&outSR=" + window.globalMap.spatialReference.wkid;
    const outputFormat = "&f=pgeojson";
    const outFields = "&outFields=*";

    const url = areaUrl + outputFormat + outSpatialRef + outFields + whereClause;
    fetch(url).then(function(response) {
      return response.json();
    })
      .then(
        (json) => {
          this.gotoArea(json, keyName)
          //this.showAreaBuildings(areaLayer, whereCl)
        }
      );
  }

  gotoArea(json, areaOrBldg) {

    if (typeof json['error'] !== "undefined") {
      console.error(json['error']);
      return 0;
    }
    if(json.features.length===0) return 0;

    const features = json.features;

    if (typeof this.polygonLayer !== "undefined") {
      window.globalMap.removeLayer(this.polygonLayer);
    }
    esriLoader.loadModules(["esri/graphic", "esri/layers/GraphicsLayer", "esri/geometry/Polygon",
      "esri/Color", "esri/symbols/SimpleFillSymbol", "esri/symbols/SimpleLineSymbol",
      "dojo/dom-construct", "esri/dijit/InfoWindow"], window.globalESRIoption)
      .then(([Graphic, GraphicsLayer, Polygon, Color, SimpleFillSymbol, SimpleLineSymbol,
              domConstruct, InfoWindow]) => {

        var polygonSymbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_NULL,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([115, 255, 223,1]), 2),
          new Color([255, 255, 0, 0.52])
        );

        this.polygonLayer = new GraphicsLayer();
        this.polygonLayer.spatialIndex = window.globalMap.spatialIndex;
        window.globalMap.addLayer(this.polygonLayer);

        //add polygon
        var polygon;
        const featureGeometry = features[0].geometry.coordinates;
        if(featureGeometry.length>1) { //for type MultiPolygon
          for (var g = 0; g < featureGeometry.length; g++) {
            polygon = new Polygon({rings: featureGeometry[g], spatialReference: window.globalMap.spatialReference});
            const polygonGraphic = new Graphic(polygon, polygonSymbol);
            this.polygonLayer.add(polygonGraphic);
          }
        } else {
          polygon = new Polygon({rings: featureGeometry,spatialReference: window.globalMap.spatialReference});
          const polygonGraphic = new Graphic(polygon, polygonSymbol);
          this.polygonLayer.add(polygonGraphic);
        }
        const pt = polygon.getCentroid()
        if(areaOrBldg==="Hist_Dist") {
          window.globalMap.setExtent(polygon.getExtent());
        } else {
          window.globalMap.centerAndZoom(pt, 19);
        }
        //const infoWindow = new InfoWindow({}, domConstruct.create("div"));
        //infoWindow.startup();
        //infoWindow.show(pt, window.globalMap.getInfoWindowAnchor(pt))

      });
  }

  showAreaBuildings (itemLayer, whereClause) {
    const buildingsLayer = itemLayer;
    buildingsLayer.setEditable(true);
    buildingsLayer.setDefinitionExpression(whereClause);
  }

  highlightBuilding (objectID) {

    const whereClause = "&where=OBJECTID" + "=" + objectID;
    const outSpatialRef = "&outSR=" + window.globalMap.spatialReference.wkid;
    const outputFormat = "&f=pgeojson";
    const outFields = "&outFields=*";

    const url = this.bldgURL + outputFormat + outSpatialRef + outFields + whereClause;
    fetch(url).then(function(response) {
      return response.json();
    })
      .then(
        (json) => {
          this.gotoArea(json, "bldg")
        }
      );
  }

  HistoricDistrictBuildingPopupTemplate() {

    // const featureLayer = new FeatureLayer({portalItem: {id: "f35eac7c21ea43f7a1539c89c6889700"}});
    // featureLayer.visible=false;
    // featureLayer.outFields = ["*"];
    // featureLayer.title = "Historic Buildings";
    // featureLayer.popupTemplate = this.HistoricDistrictBuildingPopupTemplate();
    // window.globalLayer = featureLayer;
    // window.globalMap.add(window.globalLayer);

    // [defaultBasemap: {…}, map_graphics: {…}, Geo_Form_Data_971: {…}, BORO_Poly_9547: {…}, Calendared_HD_6252: {…}, …]
    // BORO_Poly_9547: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/BORO_Poly/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Cal_Ind_SinglePoints_V2test_2364: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcg…vices/Cal_Ind_SinglePoints_V2test/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Calendared_HD_6252: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Calendared_HD/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Geo_Form_Data_971: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Geo_Form_Data/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Historic_Districts_6973: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcg…/rest/services/Historic_Districts/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Ind_Landmark_Lots_POLY_5969: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcg…t/services/Ind_Landmark_Lots_POLY/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Individual_Landmark_Lots_Points_2137: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcg…s/Individual_Landmark_Lots_Points/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Individual_Landmark_Lots_Poly_1275: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcg…ces/Individual_Landmark_Lots_Poly/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Interiors_5892: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Interiors/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Interiors_5892_1240: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Interiors/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // LPC_HistoricBuilding_DB_6548: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcg…/services/LPC_HistoricBuilding_DB/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // Scenic_9665: {_attrs: {…}, url: "https://services5.arcgis.com/Oos4pNA2538iVFA1/arcgis/rest/services/Scenic/FeatureServer/0", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // defaultBasemap: {_attrs: {…}, url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer", _url: {…}, spatialReference: {…}, initialExtent: {…}, …}
    // graphicsLayer2: {_attrs: {…}, _url: null, url: null, spatialReference: {…}, initialExtent: {…}, …}
    // map_graphics: {_attrs: {…}, _url: null, url: null, spatialReference: {…}, initialExtent: {…}, …}
    // marker-feature-action-layer: {_attrs: {…}, _url: null, url: null, spatialReference: {…}, initialExtent: {…}, …}
    // length: 0
    // __proto__: Array(0)


    /***** Arcade Expressions *****/
    // var arcadeExpressionsInfo = [
    //   {name: "Build_Nme", expression: "if($feature.Build_Nme =='0') return ''; else return ' | ' + $feature.Build_Nme;"},
    //   {name: "Alt_Date_1", expression: "if($feature.Alt_Date_1 =='0') return 'None'; else return $feature.Alt_Date_1;"},
    //   {name: "Alt_Date_2", expression: "if($feature.Alt_Date_2 =='0') return ''; else return '; ' + $feature.Alt_Date_2;"},
    //   {name: "Alt_Arch_1", expression: "if($feature.Alt_Arch_1 =='0') return 'None'; else return $feature.Alt_Arch_1;"},
    //   {name: "Alt_Arch_2", expression: "if($feature.Alt_Arch_2 =='0') return ''; else return '; ' + $feature.Alt_Arch_2;"},
    //   {name: "Style_Sec", expression: "if($feature.Style_Sec =='0') return ''; else return ', ' + $feature.Style_Sec;"},
    //   {name: "Style_Oth", expression: "if($feature.Style_Oth =='0') return ''; else return ', ' + $feature.Style_Oth;"},
    //   {name: "Mat_Sec", expression: "if($feature.Mat_Sec =='0') return ''; else return ', ' + $feature.Mat_Sec;"},
    //   {name: "Mat_Third", expression: "if($feature.Mat_Third =='0') return ''; else return ', ' + $feature.Mat_Third;"},
    //   {name: "Mat_Four", expression: "if($feature.Mat_Four =='0') return ''; else return ', ' + $feature.Mat_Four;"},
    //   {name: "Mat_Other", expression: "if($feature.Mat_Other =='0') return ''; else return ', ' + $feature.Mat_Other;"},
    //   {name: "StatusTitle", expression: "if($feature.NonContrib==1 || 2) return 'Status: '; else return '';"},
    //   {name: "Status", expression: "if($feature.NonContrib ==1) return 'Contributing'; else if($feature.NonContrib==2) return 'Non-Contributing'; else return '';"},
    //   {name: "NotesTitle", expression: "if($feature.Notes =='0') return ''; else return 'Notes: ';"},
    //   {name: "Notes", expression: "if($feature.Notes =='0') return ''; else return $feature.Notes;"},
    // ];
    //
    // return {
    //   title: "<h3 style='background-color: black; color: white; padding: 10px;'>{Des_Addres}{expression/Build_Nme}</h3>",
    //   content: [
    //     {
    //       type: "text",
    //       text: "<b>Construction Date</b>: {Date_Combo}<br>"+
    //         "<b>Architect/Builder</b>: {Arch_Build}<br>"+
    //         "<b>Owner / Developer</b>: {Own_Devel}<br>"+
    //         "<b>Major Alteration(s)</b>: {expression/Alt_Date_1}{expression/Alt_Date_2}<br>"+
    //         "<b>Alteration Architect(s)</b>: {expression/Alt_Arch_1}{expression/Alt_Arch_2}<br>"+
    //         "<b>Style(s)</b>: {Style_Prim}{expression/Style_Sec}{expression/Style_Oth}<br>"+
    //         "<b>Material(s)</b>: {Mat_Prim}{expression/Mat_Sec}{expression/Mat_Third}{expression/Mat_Four}{expression/Mat_Other}<br><br>"+
    //         "<b>Building Type</b>: {Build_Type}<br>"+
    //         "<b>Original Use</b>: {Use_Orig}<br>"+
    //         "<b>Tax Block</b>: {Block} <b>Tax Lot:</b>: {Lot}<br>"+
    //         "<b>{expression/StatusTitle}</b> {expression/Status}<br><br>"+
    //         "<b>{expression/NotesTitle}</b>{expression/Notes}<br><br>"+
    //         "All building data and notes from the {Hist_Dist} designation report."
    //     },
    //     //{type: "media", mediaInfos: [{}]},
    //     //type: "attachments","attachmentInfos":[{"name": "ABC","url": "abc.pdf"},{"name": "XYZ,"url": "xyz.pdf"}]"
    //   ],
    //   expressionInfos: arcadeExpressionsInfo
    // };
  }

}
